import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";
import {Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {LogsTypeTraductionKey} from "../../../logsType";
import Badge from "../../../../../../components/Badge";
import {grey300} from "../../../../../../assets/jss/main";
import {WMSContext} from "../../../../context/WMSContext";
import moment from "moment/moment";
import ArrowDownIcon from "../../../../../../components/icons/ArrowDownIcon";

LogShipmentItem.propTypes = {
    item: PropTypes.object.isRequired
};

function LogShipmentItem({item}) {
    const {isMobile} = useContext(WMSContext);

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ArrowDownIcon/>}>
                <Grid container direction={isMobile ? "column" : "row"} gap={"8px"} alignItems={"center"}>
                    <Badge color={"default"} rounded>
                        <span style={{fontSize: '1rem'}}>
                            {LogsTypeTraductionKey[item.event]
                                ? <FormattedMessage id={LogsTypeTraductionKey[item.event]}/>
                                : item.event
                            }
                        </span>
                    </Badge>
                    {item.data.trackingNumber && (
                        <Badge color={"default"} rounded isBold>
                            {item.data.trackingNumber}
                        </Badge>
                    )}
                    <Badge color={"default"} rounded isBold>
                        <FormattedMessage id={`wms.logs.shipmentItems.badge.status.${item.data.status}`}/>
                    </Badge>
                    <p style={{fontSize: '0.8rem'}}>
                        {item.member?.user?.fullName ?? null}
                    </p>
                </Grid>
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor: grey300}}>
                <Grid container direction={"column"} gap={"8px"}>
                    <Grid container alignItems={"center"} gap={"8px"}>
                        <FormattedMessage id={"wms.logs.shipmentLog.address.label"}/>
                        <Badge>{item.data.shipmentAddress?.address}, {item.data.shipmentAddress?.city}</Badge>
                    </Grid>
                    <Grid container alignItems={"center"} gap={"8px"}>
                        <FormattedMessage id={"wms.logs.shipmentLog.receiver.label"}/>
                        <Badge>{item.data.shipmentAddress?.firstname} {item.data.shipmentAddress?.lastname}</Badge>
                    </Grid>
                    {item.data.container && (
                        <Grid container alignItems={"center"} gap={"8px"}>
                            <FormattedMessage id={"wms.logs.shipmentLog.container.label"}/>
                            <Badge>{item.data.container.fullName}</Badge>
                            <Badge color={"online"} rounded isBold>
                                <FormattedMessage id={`wms.container.type.name.${item.data.container.type}`}/>
                            </Badge>
                        </Grid>
                    )}
                    <Grid container flexWrap={'nowrap'} alignItems={"center"}>
                        <span><FormattedMessage id={"wms.logs.wmsItems.updatedAt.label"}/></span>
                        <Badge color={"default"} rounded isBold>
                            {moment.utc(item.createdAt).local().format("DD/MM/YYYY HH:mm:ss")}
                        </Badge>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default LogShipmentItem;